import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TokensPage } from '@/features/access/tokens/tokens-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/tokens/')({ component: TokensRoute });

function TokensRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="tokens" crumbs={[{ label: t('access.tokens.title') }]}>
      <TokensPage tenantId={tenant} />
    </ConsoleShell>
  );
}
